<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Run Sheet</strong>
          </div>  


          <b-form  @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row> 

            <b-col sm="4">
               <b-col sm="12">
              <div id='container' >
              <br> 

              <b-form-group label="Delivery Agent"  :label-cols="4" >
                 <!-- <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" id="deliveryagentid"  v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.deliveryagentid') }">
                        <option :value="selected"  >--Select--</option>
                        <option v-for="agent in agentmaster"  v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                   </b-form-select> -->
                  
                   <v-select  v-model="deliveryagentid" :options="agentmaster" placeholder="Select Delivery Agent" name="deliveryagentid" id="deliveryagentid"  v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.deliveryagentid') }">
                  </v-select>
                  <span v-show="errors.has('form-1.deliveryagentid')" class="help text-danger">{{ errors.first('form-1.deliveryagentid') }}</span>
                           
                </b-form-group>  
              </div>
            </b-col>
            </b-col>
            <b-col sm="4">

            <div id='container'>
            <br>  
            <b-form-group>   
              <ejs-multiselect id='multiselect' placeholder="Select Shipment status" name="ShipmentStatus" v-model="ShipmentStatus"  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :dataSource='shipmentstatus'     :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.ShipmentStatus') }">
              </ejs-multiselect>
              <span v-show="errors.has('form-1.ShipmentStatus')" class="help text-danger">{{ errors.first('form-1.ShipmentStatus') }}</span>
               </b-form-group>  
            </div>
          </b-col>
            <b-col sm="4">
            <div>
            <br>     
               <ejs-multiselect id='multiselect' placeholder="Select Order Flow" v-model="orderFlow" name="orderFlow" :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :dataSource='orderflowoptions'     :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" >
              </ejs-multiselect>
              
            </div>
          </b-col>
                       
          
            </b-row>
              <b-row>
              <b-col sm="4">
                 <b-col sm="12">
                <b-form-group label="From Date:"  :label-cols="4" >
                 <v-date-picker mode='single' v-validate="'required'"  input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              </b-col>
              <b-col sm="4">
                <b-form-group label="To Date:"  :label-cols="4" >
                  <v-date-picker mode='single' v-validate="'required'"  input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>
              <b-col sm="3" class="text-right">
               <b-button  type="submit" size="md" variant="primary"> Search</b-button>&nbsp; 

               <b-button  @click="clear" size="md" variant="danger">Clear</b-button> &nbsp; 
                <b-button v-if="totalRows!=0"  variant="primary" size="md" value="print a div!" @click="printdata('printlist')">Print</b-button>
              </b-col>

              <b-col sm="4" class="text-right">
              <!--   <div id='container' v-if="totalRows==0" style="display: none">
                  <b-button  id="printbutton" variant="primary" size="md" value="print a div!" @click="printdata('printlist')">Print</b-button>
                </div> -->
                <div id='container'  style="display: block">
                  
                </div>
                 <!-- <b-button style="display: none; margin-left: 15px; " id="printbutton" variant="primary" size="md" value="print a div!" @click="getrunlist('printlist')">Print Receipt</b-button> -->
            </b-col>   
              
          </b-row>

            <b-row>
             <b-col md="4" class="my-1">
               <b-col md="12">
                <b-form-group label-cols-sm="4" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              </b-col>

             <b-col sm="4" v-if="country ==='KSA'">
                <b-form-group label-cols-sm="4" label="Customer Count" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="customerCount" disabled></b-form-input>                 
                  </b-input-group>
                </b-form-group>
              </b-col>
           
              <b-col sm="12" class="text-right">
                <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
             </b-col>
              </b-col>
            </b-row> 
          </b-form>  
         
<b-row>

          </b-row>    
          <b-col sm="12">
         <div id="printlist">

          <b-table show-empty stacked="md" :busy="isBusy"   :items="items" :fields="fields1"  :current-page="currentPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered" class="headsection"> 
                <template  slot="thead-top">
                  <tr>
                  <td colspan="8" bgcolor="white" style="text-align: center; font-size:18px;"><span class=""><b>Run Sheet</b></span></td></tr>
                  <td colspan="4" bgcolor="white" style="font-size: 12px;"><span class=""><b>Delivery Agent : {{this.deliveryagentname}}</b></span></td>
           
                   <td colspan="4" bgcolor="white" ><span class="" style="float: right; font-size: 12px"><b>Date: {{this.currDate}}</b></span></td>
                  <!-- <td class="totalback" ><b>Total</b></td> -->
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                 <template slot="cod_amount" slot-scope="row">
                {{ (row.item.cod_amount && row.item.cod_prepaid!='prepaid') ? row.item.cod_amount:'0' }}
                </template>


          </b-table>
        </div>
         </b-col>
    <!--       <b-col md="6" class="my-1" v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> -->
        </b-card>
      </b-col>
    </b-row>    
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import { EventBus } from "./event-bus.js";


export default {
  data: function() {
    return {

      agentmaster: [],
      deliveryagentid:'',
      deliveryagentname:'',
      shipmenttype:'',
      selected:'',
      options: [],
      showSelectAll : true,
      fields: { text: 'name', value: 'id' },
      allowCustomValue : true,
      value2:"",
      value1:[],
      ShipmentStatus:[],
      orderFlow:[],
      value5:[],
      currDate:this.currdate(new Date()),
      customer: {},
      shipmentstatus:['BookingDone','OFD'],
      orderflowoptions:['forward','reverse'],
      isBusy: false,
      items:[],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      bordered: true,
      filter: null,
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      totalRows: 0,
      currentPage: 1,
     // perPage:  10,
      pageOptions: [5, 10, 15],
      flowfields : { text: 'flow', value: 'Id' },
      fields1: [
          { key: 'awb_no', label: 'AWBno', sortable: true,tdClass: 'tablestyle'},
          // { key: 'poid', label: 'POID', sortable: true},
          { key: 'customername', label: 'Customer Name', sortable: true,tdClass: 'tablestyle'},

          
          // { key: 'area', label: 'Area', sortable: true,tdClass: 'tablestyle' }, 
          { key: 'shipmobilenumber', label: 'Mobile No.', sortable: true,tdClass: 'tablestyle'}, 
          { key: 'address', label: 'Address', sortable: true, tdClass: 'tablestyle' },
           { key: 'shipaddress_type', label: 'Address Type', sortable: true, tdClass: 'tablestyle' },
          
          { key: 'cod_prepaid', label: 'COD /Prepaid', sortable: true,tdClass: 'tablestyle' },
          { key: 'cod_amount', label: 'COD Amount' , sortable: true,tdClass: 'tablestyle'},

      ],

      customerCount: 0,
      country:'',
    
    };
  },
 
  created: function() {   
     this.displaydeliveryagent();
    //this.getrunlist();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
// console.log("userInfouserInfouserInfouserInfo",userInfo.country
// )
    this.country = userInfo.country


  },
 
  methods: {
 

     displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;

           for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
        name: this.agentmaster[i].deliveryagentfirstname,
        id: this.agentmaster[i].deliveryagentmasterid
      }
      this.options.push(deliveryagent2);
 
       }
       var data = [];
       result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentfirstname + ' ' + srData.deliveryagentlastname + ' - ' + srData.deliveryagentmasterid,
            });
          });
          this.agentmaster = data;
       // console.log('--------gfg----------');
       // console.log(this.options);
       //        console.log('------------------');

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
     onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering

      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    printdata(printlist){

    var printContents = document.getElementById("printlist").innerHTML;
    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      // docprint.document.write(`<header class="onlyprint"><Heloooooooooooooo></header>`);
      //   docprint.document.write("@media screen {header.onlyprint, footer.onlyprint{display: none; }}`);
      // docprint.document.write("@media print {header.onlyprint {position: fixed; top: 0;}}");
      // docprint.document.write('<h2> <span class="badge badge-secondary" style="margin-left: 300px !important;">Run Sheet</span></h2>');
      // docprint.document.write('<header><h2> <span class="badge badge-secondary" style="margin-left: 300px !important; >Run Sheet</span></h2></header>');
      // docprint.document.write('<label style="text-align:center;margin-left: 350px ;position: fixed; top:0px}">Run Sheet</label>');
      // docprint.document.write(' <thead class="report-header"><tr><th class="report-header-cell"><div class="header-info"><h2> <span class="badge badge-secondary" style="margin-left: 300px !important;">Run Sheet</span></h2> Sheet</div></th></tr></thead>');
      
      docprint.document.write('<style type="text/css">body{ margin:20px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.printlist{ border-collapse: collapse;margin-bottom: 10px; width:540px;height:540px  } ');
      docprint.document.write('.table {width: 100%;margin-bottom: 1rem;background-color: transparent;}');
      docprint.document.write('.table-bordered {border: 2px solid #c8ced3;}');
      docprint.document.write('table {border-collapse: collapse;}');
      docprint.document.write('.table thead, .table thead tr:hover {background: #ECEFF1 !important;}');
      docprint.document.write('.table thead, .table thead tr {background: #ECEFF1 !important;word-wrap: break-word;}');
       docprint.document.write('tr {display: table-row;vertical-align: inherit;border-color: inherit;}');
        docprint.document.write('td {display: table-cell;}');
        //common heading
        docprint.document.write('td {<label style="text-align:center;margin-left: 350px ;position: fixed; top:0px}">Run Sheet</label>}');
        docprint.document.write('tbody {display: table-row-group;vertical-align: middle;border-color: inherit;}');
        docprint.document.write('.headsection{font-size: 12px;}');
        //common heading end
        docprint.document.write('.table th, .table td {padding: .5rem!important;vertical-align: top!important;}');
      
        docprint.document.write('.table tr th {color: #333 !important;}');
      docprint.document.write('.table th, .table td {padding: .5rem!important;vertical-align: top!important;}');
      docprint.document.write('.table-bordered th, .table-bordered td {border: 1px solid #c8ced3;}');
      docprint.document.write('.table th, .table td {padding: .1rem!important;vertical-align: top!important;}');
      docprint.document.write('.slothead{display: block;}');
      

       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');
       // docprint.document.write('.table.b-table > thead > tr > td[aria-sort], .table.b-table > tfoot > tr > th[aria-sort] {width: 200px;');
      docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        

        docprint.document.write('@page { size: 297mm 210mm; margin-top:40px;margin-bottom:40px; margin-right:20px;margin-left:1px;}</style>');
        

       docprint.document.write('</head><body onLoad="self.print()"><center>');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();

       //self.close();

    },



validateForm(scope) {
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     // 
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
         this.isBusy = true;
      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
    
    var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
    var deliveryagentname_sel = document.getElementById("deliveryagentid");

    console.log("88888888888888",deliveryagentname_sel )

//      this.deliveryagentname = deliveryagentname_sel.options[deliveryagentname_sel.selectedIndex].text;

// console.log("$$$$$$$$$$$",this.deliveryagentname )

     var vendorarr=[];
          vendorarr=this.value3;

          var statusarr=[];
          statusarr=this.ShipmentStatus;
          
         
        var orderarr=[];
          orderarr=this.orderFlow;
            
      var vendorid = vendorarr;
           
           
           let obj = {
        

         deliveryagentid:deliveryagentid.key,
        //deliveryagentid:deliveryagentidarr,
        status:statusarr,
        orderflow:orderarr,
        
        fromdate:`${fromdate}`, 
        todate:`${formatdateto}`,
         hub_id:`${userInfo.pickuplocationmasterid}`,

      }

        this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getrunsheetlist`,obj)
            .then(result => {
              // console.log(result.body);
                this.isBusy = !this.isBusy;
                if(result.body.returnmsg =="Successful"){
                  // console.log("result.body.returnvalue",result.body.returnvalue);
                  //this.assigned = result.body.returnvalue;
                 // this.items  = result.body.returnvalue;
                  //this.totalRows = result.body.returnvalue.length
                   
                  this.items =result.body.returnvalue;
                  //console.log("Heloooooooooooooo",this.items.vendor_name);
                  //var deliveryagentnamearr=this.items.vendor_name;
          //deliveryagentnamearr=this.value1;
                  
                  this.totalRows = result.body.returnvalue.length;
                  this.customerCount = result.body.returnvalue[0].customer_count;
                }else {
                 this.items  = [];
                 this.totalRows = 0
                }
            }).catch(ex => {
              console.log('error', ex)
            })
          }
        })
    },

   //  barcodedata(printlist){


   //    //document.getElementById("printableArea").style.display = "none";

   //   var printContents = document.getElementById("printlist").innerHTML;
   // },

     getrunlist(){
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      document.getElementById("printlist").style.display = "block";
      this.isBusy = true;
      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
    
    var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
     var deliveryagentname_sel = document.getElementById("deliveryagentid");

    //  this.deliveryagentname = deliveryagentname_sel.options[deliveryagentname_sel.selectedIndex].text;
     
        var vendorarr=[];
          vendorarr=this.value3;

          var statusarr=[];
          statusarr=this.ShipmentStatus;
          
         
        var orderarr=[];
          orderarr=this.orderFlow;

           var vendorid = vendorarr;
           
           
           let obj = {
        

        deliveryagentid:deliveryagentid.key,
        status:statusarr,
        orderflow:orderarr,
        
        fromdate:`${fromdate}`, 
        todate:`${formatdateto}`,
        hub_id:`${userInfo.pickuplocationmasterid}`,


      }



    this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getrunsheetlist`,obj)
            .then(result => {
              // console.log(result.body);
                this.isBusy = !this.isBusy;
                if(result.body.returnmsg =="Successful"){
                
                   
                  this.items =result.body.returnvalue;
                
                  this.totalRows = result.body.returnvalue.length;
                }else {
                 this.items  = [];
                 this.totalRows = 0
                }
            }).catch(ex => {
              console.log('error', ex)
            })
          //}
      },


     formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

      currdate: function(date){
        var d = new Date(),
      minutes = d.getMinutes().toString().length == 1 ? '0'+d.getMinutes() : d.getMinutes(),
      hours = d.getHours().toString().length == 1 ? '0'+d.getHours() : d.getHours(),
      ampm = d.getHours() >= 12 ? 'pm' : 'am',
      months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  return days[d.getDay()]+' '+months[d.getMonth()]+' '+d.getDate()+' '+d.getFullYear();
  },
     CloseWindow() {
        docprint.close();
    },
      clear: function () {
   //console.log(this.tags.length);
      this.items=[];
      this.deliveryagentid='';
      this.ShipmentStatus='';
      this.orderFlow=[];
      this.totalRows=0;
      this.customer = {};
      this.selectDateFrom = new Date();
        this.selectDateTo = new Date();
        this.customerCount = 0;
     // this.invalidshipppingid="";
      this.errors.clear('form-1')
    },


  }, //method ends

      

  

};

</script>
<style lang="css">
.table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}

.table-bordered {
    border: 1px solid #c8ced3;
}
table {
    border-collapse: collapse;
}
.table thead, .table thead tr:hover {
    background: #ECEFF1 !important;
}
.table thead, .table thead tr {
    background: #ECEFF1 !important;
    word-wrap: break-word;
}
tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}


  .nameOfTheClass {
   width: 150px;
}
.headsection{
  font-size: 12px;
}
</style>